// Produtos.js - CORREÇÃO (PRECO DE VENDA COM IVA INCLUÍDO AUTOMATICAMENTE)
// 🔥 IVA CORRIGIDO: O PRECO DE VENDA É CALCULADO COM IVA EM TEMPO REAL
// 🔥 CORRIGIDO: CAMPO PRECO VENDA NÃO ACEITA VÍRGULAS
// 🔥 NOVO: CAMPO PRECO UNITARIO (BASE) E PRECO VENDA (COM IVA)
// 🔥 REMOVIDO: PRECO COM IVA DA TAB IMPOSTOS

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './CriarProdutos.css';
import { Icon } from './SharedComponents';

const API_BASE_URL = '/api';

// ==============================================
// CONFIGURAÇÕES PADRÃO (fallback)
// ==============================================
const CONFIG_PADRAO = {
    moeda: {
        simbolo: 'MT',
        codigo: 'MZN',
        casasDecimais: 2,
        separadorDecimal: ',',
        separadorMilhar: '.'
    },
    formatoData: 'DD/MM/YYYY',
    timezone: 'Africa/Maputo',
    idioma: 'pt-PT',
    iva: null
};

// ==============================================
// CONSTANTES
// ==============================================
const UNIDADES_MEDIDA = [
    { value: 'UN', label: 'Unidade' },
    { value: 'KG', label: 'Quilograma' },
    { value: 'L', label: 'Litro' },
    { value: 'M', label: 'Metro' },
    { value: 'CX', label: 'Caixa' },
    { value: 'PCT', label: 'Pacote' }
];

// 🔥 COMPONENTE DE GRÁFICO COM FORMATAÇÃO
const SimpleBarChart = ({ data, labels, colors, title, formatValue }) => {
    const maxValue = Math.max(...data, 1);

    return (
        <div className="simple-chart">
            {title && <h4 className="chart-title">{title}</h4>}
            <div className="chart-bars">
                {data.map((value, index) => {
                    const percentage = (value / maxValue) * 100;
                    const color = colors?.[index] || '#4f46e5';
                    const displayValue = formatValue ? formatValue(value) : value;
                    return (
                        <div key={index} className="chart-bar-wrapper">
                            <div className="chart-bar-label">{labels[index]}</div>
                            <div className="chart-bar-track">
                                <div
                                    className="chart-bar-fill"
                                    style={{
                                        width: `${Math.max(percentage, 5)}%`,
                                        backgroundColor: color
                                    }}
                                >
                                    <span className="chart-bar-value">{displayValue}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

// 🔥 COMPONENTE DE GAUGE COM FORMATAÇÃO
const SimpleGauge = ({ value, max, label, color, formatValue }) => {
    const percentage = Math.min((value / max) * 100, 100);
    const circumference = 2 * Math.PI * 40;
    const offset = circumference - (percentage / 100) * circumference;
    const displayValue = formatValue ? formatValue(value) : value;

    return (
        <div className="simple-gauge">
            <svg viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" strokeWidth="8" />
                <circle
                    cx="50"
                    cy="50"
                    r="40"
                    fill="none"
                    stroke={color || '#4f46e5'}
                    strokeWidth="8"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    transform="rotate(-90 50 50)"
                />
                <text x="50" y="50" textAnchor="middle" dominantBaseline="central" className="gauge-value">
                    {displayValue}
                </text>
            </svg>
            <div className="gauge-label">{label}</div>
        </div>
    );
};

export default function Produtos() {

    // ==============================================
    // ESTADOS PRINCIPAIS
    // ==============================================
    const [produtos, setProdutos] = useState([]);
    const [filteredProdutos, setFilteredProdutos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [configEmpresa, setConfigEmpresa] = useState(CONFIG_PADRAO);

    // ==============================================
    // MODAIS
    // ==============================================
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [produtoToDelete, setProdutoToDelete] = useState(null);
    const [produtoDetalhes, setProdutoDetalhes] = useState(null);
    const [message, setMessage] = useState({ text: '', type: '' });

    // ==============================================
    // 🔥 TABS DOS MODAIS
    // ==============================================
    const [activeTab, setActiveTab] = useState('geral');
    const [editActiveTab, setEditActiveTab] = useState('geral');
    const [detailsActiveTab, setDetailsActiveTab] = useState('dados');

    // ==============================================
    // 🔥 ESTADOS PARA ENTRADA DE STOCK NO MODAL DE CRIAÇÃO
    // ==============================================
    const [stockFormData, setStockFormData] = useState({
        quantidade: 1,
        precoUnitario: 0,
        fornecedorId: '',
        notaFiscal: '',
        observacao: ''
    });
    const [fornecedores, setFornecedores] = useState([]);
    const [armazens, setArmazens] = useState([]);

    // ==============================================
    // PAGINAÇÃO
    // ==============================================
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        pages: 0
    });

    // ==============================================
    // 🔥 PAGINAÇÃO PARA O HISTÓRICO NO MODAL DE DETALHES
    // ==============================================
    const [historicoPagination, setHistoricoPagination] = useState({
        page: 1,
        limit: 6,
        total: 0,
        pages: 0
    });

    // ==============================================
    // ESTADOS DE USUÁRIO E EMPRESA
    // ==============================================
    const [isSuperadmin, setIsSuperadmin] = useState(false);
    const [loggedUser, setLoggedUser] = useState(null);
    const [empresaId, setEmpresaId] = useState(null);
    const [categorias, setCategorias] = useState([]);

    // ==============================================
    // LOADING STATES
    // ==============================================
    const [createLoading, setCreateLoading] = useState(false);
    const [createMessage, setCreateMessage] = useState({ text: '', type: '' });
    const [editLoading, setEditLoading] = useState(false);
    const [editMessage, setEditMessage] = useState({ text: '', type: '' });

    // ==============================================
    // ESTATÍSTICAS
    // ==============================================
    const [stats, setStats] = useState({
        total: 0,
        comStock: 0,
        semStock: 0,
        baixoStock: 0,
        valorTotalStock: 0
    });

    // ==============================================
    // FILTROS AVANÇADOS
    // ==============================================
    const [filtros, setFiltros] = useState({
        categoria: 'todos',
        fornecedor: 'todos',
        statusStock: 'todos',
        unidadeMedida: 'todos',
        ativo: 'todos'
    });
    const [showFiltros, setShowFiltros] = useState(false);

    // ==============================================
    // FORM DATA - CRIAÇÃO
    // ==============================================
    const [formData, setFormData] = useState({
        nome: '',
        descricao: '',
        codigo: '',
        precoUnitario: '',  // 🔥 Preço base sem IVA
        precoVenda: '',     // 🔥 Preço com IVA (calculado automaticamente)
        precoCompra: '',
        compraQuantidade: 0,
        stockAtual: 0,
        stockMinimo: 0,
        unidadeMedida: 'UN',
        categoriaId: '',
        armazemId: '',
        ativo: true,
        impostos: {
            iva: null,
            ispc: 0,
            usarIvaEmpresa: true
        }
    });

    // ==============================================
    // FORM DATA - EDIÇÃO
    // ==============================================
    const [editFormData, setEditFormData] = useState(null);

    // ==============================================
    // API INSTANCE
    // ==============================================
    const api = axios.create({
        baseURL: API_BASE_URL,
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Cache-Control': 'no-cache'
        }
    });

    // ==============================================
    // FUNÇÕES AUXILIARES
    // ==============================================
    const extrairEmpresaId = (empresa) => {
        if (!empresa) return null;
        if (typeof empresa === 'string') return empresa;
        if (typeof empresa === 'object' && empresa._id) return empresa._id;
        if (typeof empresa === 'object' && empresa.id) return empresa.id;
        return null;
    };

    const obterEmpresaIdDoUtilizador = (user) => {
        if (!user) return null;
        let id = extrairEmpresaId(user.empresaId);
        if (id) return id;
        id = extrairEmpresaId(user.empresa);
        if (id) return id;
        id = extrairEmpresaId(user.empresaAtual);
        if (id) return id;
        if (user.empresas && Array.isArray(user.empresas) && user.empresas.length > 0) {
            id = extrairEmpresaId(user.empresas[0]);
            if (id) return id;
        }
        return null;
    };

    const showTempToast = (title, message, type = 'success') => {
        setMessage({ text: `${title}: ${message}`, type });
        setTimeout(() => setMessage({ text: '', type: '' }), 4000);
    };

    // ==============================================
    // 🔥 FORMATAÇÃO DE DATA/HORA
    // ==============================================
    const formatarDataHora = (data) => {
        if (!data) return '-';
        const d = new Date(data);
        const dia = String(d.getDate()).padStart(2, '0');
        const mes = String(d.getMonth() + 1).padStart(2, '0');
        const ano = d.getFullYear();
        const horas = String(d.getHours()).padStart(2, '0');
        const minutos = String(d.getMinutes()).padStart(2, '0');
        return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
    };

    const getDataHoraLocalInput = () => {
        const now = new Date();
        const ano = now.getFullYear();
        const mes = String(now.getMonth() + 1).padStart(2, '0');
        const dia = String(now.getDate()).padStart(2, '0');
        const horas = String(now.getHours()).padStart(2, '0');
        const minutos = String(now.getMinutes()).padStart(2, '0');
        return `${ano}-${mes}-${dia}T${horas}:${minutos}`;
    };

    // ==============================================
    // FORMATAÇÃO
    // ==============================================
    const formatarMoeda = (valor) => {
        const moeda = configEmpresa?.moeda || CONFIG_PADRAO.moeda;
        const { simbolo = 'MT', casasDecimais = 2, separadorDecimal = ',', separadorMilhar = '.' } = moeda;

        if (valor === undefined || valor === null || isNaN(valor)) {
            return `0${separadorDecimal}${'0'.repeat(casasDecimais)} ${simbolo}`;
        }

        let numero = Number(valor);
        if (isNaN(numero)) {
            return `0${separadorDecimal}${'0'.repeat(casasDecimais)} ${simbolo}`;
        }

        numero = numero.toFixed(casasDecimais);
        const partes = numero.split('.');
        let inteiros = partes[0];
        const decimais = partes[1] || '0'.repeat(casasDecimais);

        inteiros = inteiros.replace(/\B(?=(\d{3})+(?!\d))/g, separadorMilhar);

        return `${inteiros}${separadorDecimal}${decimais} ${simbolo}`;
    };

    const formatarNumero = (valor) => {
        if (valor === undefined || valor === null) return '0';
        const num = Number(valor);
        if (isNaN(num)) return '0';

        if (num >= 1e9) {
            return (num / 1e9).toFixed(1) + 'B';
        }
        if (num >= 1e6) {
            return (num / 1e6).toFixed(1) + 'M';
        }
        if (num >= 1e3) {
            return (num / 1e3).toFixed(1) + 'k';
        }

        return num.toLocaleString('pt-PT');
    };

    const formatarPercentagem = (valor) => {
        if (valor === undefined || valor === null) return '0%';
        return `${Number(valor).toFixed(1)}%`;
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA CALCULAR O PREÇO COM IVA (CORRIGIDA)
    // ==============================================
    const calcularPrecoComIVA = (precoSemIVA, iva) => {
        if (!precoSemIVA || precoSemIVA <= 0) return null;
        if (iva === null || iva === undefined || iva === 0) return precoSemIVA;
        // 🔥 CONVERTE A PERCENTAGEM PARA DECIMAL (ex: 16 -> 0.16)
        const taxaIVA = Number(iva) / 100;
        return precoSemIVA * (1 + taxaIVA);
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA CALCULAR O PREÇO SEM IVA (INVERSO - CORRIGIDA)
    // ==============================================
    const calcularPrecoSemIVA = (precoComIVA, iva) => {
        if (!precoComIVA || precoComIVA <= 0) return null;
        if (iva === null || iva === undefined || iva === 0) return precoComIVA;
        // 🔥 CONVERTE A PERCENTAGEM PARA DECIMAL (ex: 16 -> 0.16)
        const taxaIVA = Number(iva) / 100;
        return precoComIVA / (1 + taxaIVA);
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA OBTER O IVA EFETIVO
    // ==============================================
    const getIvaEfetivo = (impostos) => {
        if (!impostos) return null;

        if (impostos.usarIvaEmpresa) {
            return configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? configEmpresa.iva : null;
        }

        return impostos.iva !== null && impostos.iva !== undefined ? impostos.iva : null;
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA SANITIZAR PREÇO (REMOVE VÍRGULAS E CARACTERES)
    // ==============================================
    const sanitizarPreco = (valor) => {
        if (!valor) return '';
        // Remove tudo que não for número ou ponto
        let val = valor.replace(/[^0-9.]/g, '');
        // Garante que só tenha um ponto
        const partes = val.split('.');
        if (partes.length > 2) {
            val = partes[0] + '.' + partes.slice(1).join('');
        }
        // Se começar com ponto, adiciona 0 na frente
        if (val.startsWith('.')) {
            val = '0' + val;
        }
        return val;
    };

    // ==============================================
    // BADGES E ÍCONES
    // ==============================================
    const getStatusStock = (stock, stockMinimo = 0) => {
        if (stock === 0) return { label: 'Sem Stock', color: '#dc2626', icon: 'block', class: 'sem-stock' };
        if (stock <= stockMinimo) return { label: 'Stock Baixo', color: '#f59e0b', icon: 'warning', class: 'baixo-stock' };
        if (stock < 10) return { label: 'Stock Médio', color: '#3b82f6', icon: 'info', class: 'stock-medio' };
        return { label: 'Stock Alto', color: '#10b981', icon: 'check_circle', class: 'stock-alto' };
    };

    const getUnidadeLabel = (value) => {
        const found = UNIDADES_MEDIDA.find(u => u.value === value);
        return found ? found.label : value || '-';
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA OBTER NOME DO FORNECEDOR POR ID
    // ==============================================
    const getNomeFornecedor = (fornecedorId) => {
        if (!fornecedorId) return '-';
        if (typeof fornecedorId === 'object' && fornecedorId.nome) {
            return fornecedorId.nome;
        }
        if (typeof fornecedorId === 'string') {
            const encontrado = fornecedores.find(f => f._id === fornecedorId);
            return encontrado ? encontrado.nome : fornecedorId;
        }
        return '-';
    };

    // ==============================================
    // CALCULAR ESTATÍSTICAS
    // ==============================================
    const calcularStats = (produtosData) => {
        const data = Array.isArray(produtosData) ? produtosData : [];

        const newStats = {
            total: data.length,
            comStock: data.filter(p => p.stockAtual > 0).length,
            semStock: data.filter(p => p.stockAtual === 0).length,
            baixoStock: data.filter(p => p.stockAtual > 0 && p.stockAtual <= (p.stockMinimo || 0)).length,
            valorTotalStock: data.reduce((sum, p) => sum + ((p.precoCompra || 0) * (p.stockAtual || 0)), 0)
        };
        setStats(newStats);
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA ORDENAR PRODUTOS (MAIS RECENTES PRIMEIRO)
    // ==============================================
    const ordenarProdutos = (lista) => {
        return [...lista].sort((a, b) => {
            const dataA = a.createdAt ? new Date(a.createdAt) : new Date(0);
            const dataB = b.createdAt ? new Date(b.createdAt) : new Date(0);
            return dataB.getTime() - dataA.getTime();
        });
    };

    // ==============================================
    // BUSCAR DADOS
    // ==============================================
    const fetchProdutos = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setLoading(false);
                return;
            }

            const response = await api.get('/produtos');

            let produtosData = [];
            let config = { ...CONFIG_PADRAO };

            if (response.data) {
                if (response.data.data && Array.isArray(response.data.data)) {
                    produtosData = response.data.data;
                    if (response.data.configuracao) {
                        config = {
                            ...CONFIG_PADRAO,
                            ...response.data.configuracao,
                            moeda: {
                                ...CONFIG_PADRAO.moeda,
                                ...(response.data.configuracao.moeda || {})
                            }
                        };
                    }
                } else if (Array.isArray(response.data)) {
                    produtosData = response.data;
                }
            }

            if (!config.moeda) {
                config.moeda = { ...CONFIG_PADRAO.moeda };
            }
            if (!config.moeda.simbolo) config.moeda.simbolo = CONFIG_PADRAO.moeda.simbolo;
            if (!config.moeda.casasDecimais) config.moeda.casasDecimais = CONFIG_PADRAO.moeda.casasDecimais;
            if (!config.moeda.separadorDecimal) config.moeda.separadorDecimal = CONFIG_PADRAO.moeda.separadorDecimal;
            if (!config.moeda.separadorMilhar) config.moeda.separadorMilhar = CONFIG_PADRAO.moeda.separadorMilhar;

            setConfigEmpresa(config);

            const produtosOrdenados = ordenarProdutos(produtosData);
            setProdutos(produtosOrdenados);
            setFilteredProdutos(produtosOrdenados);
            calcularStats(produtosOrdenados);
            setPagination({
                ...pagination,
                total: produtosOrdenados.length,
                pages: Math.ceil(produtosOrdenados.length / pagination.limit),
                page: 1
            });
        } catch (err) {
            console.error('❌ Erro ao carregar produtos:', err);
            showTempToast('Erro', 'Não foi possível carregar os produtos', 'danger');
            setConfigEmpresa(CONFIG_PADRAO);
        } finally {
            setLoading(false);
        }
    };

    const fetchCategorias = async () => {
        try {
            const response = await api.get('/categorias');
            if (response.data) {
                const categoriasData = Array.isArray(response.data) ? response.data : response.data.data || [];
                setCategorias(categoriasData);
            }
        } catch (err) {
            console.error('❌ Erro ao carregar categorias:', err);
        }
    };

    const fetchFornecedores = async () => {
        try {
            const response = await api.get('/fornecedores');
            if (response.data) {
                const fornecedoresData = Array.isArray(response.data) ? response.data : response.data.data || [];
                setFornecedores(fornecedoresData);
                console.log('✅ Fornecedores carregados:', fornecedoresData.length);
            }
        } catch (err) {
            console.error('❌ Erro ao carregar fornecedores:', err);
        }
    };

    // ==============================================
    // 🔥 BUSCAR ARMAZÉNS
    // ==============================================
    const fetchArmazens = async () => {
        try {
            console.log('📦 Buscando armazéns para produtos...');
            const response = await api.get('/armazens');
            console.log('📦 Resposta armazéns:', response.data);
            if (response.data) {
                const armazensData = Array.isArray(response.data) ? response.data : response.data.data || [];
                setArmazens(armazensData);
                console.log(`✅ Encontrados ${armazensData.length} armazéns`);
                armazensData.forEach(arm => {
                    console.log(`🏠 Armazém: ${arm.nome} (ID: ${arm._id})`);
                });
            }
        } catch (err) {
            console.error('❌ Erro ao carregar armazéns:', err);
        }
    };

    const fetchLoggedUser = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                const storedUser = JSON.parse(localStorage.getItem('usuario') || '{}');
                if (storedUser && storedUser._id) {
                    setLoggedUser(storedUser);
                    setIsSuperadmin(storedUser.perfil === 'Superadmin');
                    const empresaIdExtraido = obterEmpresaIdDoUtilizador(storedUser);
                    setEmpresaId(empresaIdExtraido);
                    return storedUser;
                }
                return null;
            }

            const response = await axios.get(`/api/users/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success) {
                const userData = response.data.data;
                setLoggedUser(userData);
                setIsSuperadmin(userData.perfil === 'Superadmin');
                const empresaIdExtraido = obterEmpresaIdDoUtilizador(userData);
                setEmpresaId(empresaIdExtraido);
                localStorage.setItem('usuario', JSON.stringify(userData));
                return userData;
            }
        } catch (err) {
            console.error('❌ Erro ao buscar utilizador:', err);
        }
        return null;
    };

    // ==============================================
    // FILTRAR PRODUTOS (MANTÉM ORDEM)
    // ==============================================
    useEffect(() => {
        filtrarProdutos();
    }, [searchTerm, produtos, filtros]);

    const filtrarProdutos = () => {
        let resultados = [...produtos];

        if (searchTerm && searchTerm.trim() !== '') {
            const term = searchTerm.toLowerCase().trim();
            resultados = resultados.filter(p => {
                const nome = p.nome || '';
                const codigo = p.codigo || '';
                const descricao = p.descricao || '';
                const categoria = p.categoriaId?.nome || '';
                const fornecedor = p.fornecedorId?.nome || '';

                return nome.toLowerCase().includes(term) ||
                    codigo.toLowerCase().includes(term) ||
                    descricao.toLowerCase().includes(term) ||
                    categoria.toLowerCase().includes(term) ||
                    fornecedor.toLowerCase().includes(term);
            });
        }

        if (filtros.categoria && filtros.categoria !== 'todos') {
            resultados = resultados.filter(p =>
                p.categoriaId?._id === filtros.categoria ||
                p.categoriaId === filtros.categoria
            );
        }

        if (filtros.fornecedor && filtros.fornecedor !== 'todos') {
            resultados = resultados.filter(p =>
                p.fornecedorId?._id === filtros.fornecedor ||
                p.fornecedorId === filtros.fornecedor
            );
        }

        if (filtros.statusStock && filtros.statusStock !== 'todos') {
            if (filtros.statusStock === 'sem_stock') {
                resultados = resultados.filter(p => p.stockAtual === 0);
            } else if (filtros.statusStock === 'baixo_stock') {
                resultados = resultados.filter(p => p.stockAtual > 0 && p.stockAtual <= (p.stockMinimo || 0));
            } else if (filtros.statusStock === 'stock_medio') {
                resultados = resultados.filter(p => p.stockAtual > (p.stockMinimo || 0) && p.stockAtual < 10);
            } else if (filtros.statusStock === 'stock_alto') {
                resultados = resultados.filter(p => p.stockAtual >= 10);
            }
        }

        if (filtros.unidadeMedida && filtros.unidadeMedida !== 'todos') {
            resultados = resultados.filter(p => p.unidadeMedida === filtros.unidadeMedida);
        }

        if (filtros.ativo && filtros.ativo !== 'todos') {
            const isAtivo = filtros.ativo === 'ativo';
            resultados = resultados.filter(p => p.ativo === isAtivo);
        }

        resultados = ordenarProdutos(resultados);

        setFilteredProdutos(resultados);
        calcularStats(resultados);
        setPagination(prev => ({
            ...prev,
            total: resultados.length,
            pages: Math.ceil(resultados.length / prev.limit),
            page: 1
        }));
    };

    const limparFiltros = () => {
        setFiltros({
            categoria: 'todos',
            fornecedor: 'todos',
            statusStock: 'todos',
            unidadeMedida: 'todos',
            ativo: 'todos'
        });
        setSearchTerm('');
        setShowFiltros(false);
    };

    // ==============================================
    // CARREGAR DADOS INICIAIS
    // ==============================================
    useEffect(() => {
        const carregarDados = async () => {
            await fetchLoggedUser();
            await Promise.all([
                fetchProdutos(),
                fetchCategorias(),
                fetchFornecedores(),
                fetchArmazens()
            ]);
        };
        carregarDados();
    }, []);

    // ==============================================
    // 🔥 SINCRONIZAR PREÇO DE COMPRA COM PREÇO UNITÁRIO DO STOCK
    // ==============================================
    useEffect(() => {
        const precoCompra = parseFloat(formData.precoCompra);
        if (precoCompra > 0) {
            setStockFormData(prev => ({
                ...prev,
                precoUnitario: precoCompra
            }));
        }
    }, [formData.precoCompra]);

    // ==============================================
    // 🔥 SINCRONIZAR QUANTIDADE DO STOCK COM STOCK ATUAL
    // ==============================================
    useEffect(() => {
        const quantidade = parseInt(stockFormData.quantidade);
        if (quantidade > 0) {
            setFormData(prev => ({
                ...prev,
                stockAtual: quantidade,
                compraQuantidade: quantidade
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                stockAtual: 0,
                compraQuantidade: 0
            }));
        }
    }, [stockFormData.quantidade]);

    // ==============================================
    // 🔥 ATUALIZAR PAGINAÇÃO DO HISTÓRICO QUANDO O HISTÓRICO MUDA
    // ==============================================
    useEffect(() => {
        if (produtoDetalhes && produtoDetalhes.historicoEntradas) {
            const total = produtoDetalhes.historicoEntradas.length;
            const pages = Math.ceil(total / historicoPagination.limit) || 1;
            setHistoricoPagination(prev => ({
                ...prev,
                total: total,
                pages: pages,
                page: prev.page > pages ? 1 : prev.page
            }));
        }
    }, [produtoDetalhes]);

    // ==============================================
    // 🔥 EFECTO PARA CALCULAR PREÇO DE VENDA A PARTIR DO PREÇO UNITÁRIO (CRIAÇÃO)
    // ==============================================
    const isUpdatingPrice = useRef(false);

    useEffect(() => {
        if (isUpdatingPrice.current) return;

        const precoUnitario = parseFloat(formData.precoUnitario) || 0;
        const ivaEfetivo = getIvaEfetivo(formData.impostos);

        if (precoUnitario > 0 && ivaEfetivo !== null && ivaEfetivo !== undefined) {
            const precoComIva = calcularPrecoComIVA(precoUnitario, ivaEfetivo);

            if (precoComIva !== null) {
                isUpdatingPrice.current = true;
                setFormData(prev => ({
                    ...prev,
                    precoVenda: Math.round(precoComIva * 100) / 100
                }));
                setTimeout(() => {
                    isUpdatingPrice.current = false;
                }, 100);
            }
        } else if (precoUnitario > 0 && (ivaEfetivo === null || ivaEfetivo === undefined)) {
            isUpdatingPrice.current = true;
            setFormData(prev => ({
                ...prev,
                precoVenda: precoUnitario
            }));
            setTimeout(() => {
                isUpdatingPrice.current = false;
            }, 100);
        }
    }, [formData.precoUnitario, formData.impostos.iva, formData.impostos.usarIvaEmpresa]);

    // ==============================================
    // 🔥 EFECTO PARA CALCULAR PREÇO DE VENDA A PARTIR DO PREÇO UNITÁRIO (EDIÇÃO)
    // ==============================================
    const isUpdatingEditPrice = useRef(false);

    useEffect(() => {
        if (!editFormData) return;
        if (isUpdatingEditPrice.current) return;

        const precoUnitario = parseFloat(editFormData.precoUnitario) || 0;
        const ivaEfetivo = getIvaEfetivo(editFormData.impostos);

        if (precoUnitario > 0 && ivaEfetivo !== null && ivaEfetivo !== undefined) {
            const precoComIva = calcularPrecoComIVA(precoUnitario, ivaEfetivo);

            if (precoComIva !== null) {
                isUpdatingEditPrice.current = true;
                setEditFormData(prev => ({
                    ...prev,
                    precoVenda: Math.round(precoComIva * 100) / 100
                }));
                setTimeout(() => {
                    isUpdatingEditPrice.current = false;
                }, 100);
            }
        } else if (precoUnitario > 0 && (ivaEfetivo === null || ivaEfetivo === undefined)) {
            isUpdatingEditPrice.current = true;
            setEditFormData(prev => ({
                ...prev,
                precoVenda: precoUnitario
            }));
            setTimeout(() => {
                isUpdatingEditPrice.current = false;
            }, 100);
        }
    }, [editFormData?.precoUnitario, editFormData?.impostos?.iva, editFormData?.impostos?.usarIvaEmpresa]);

    // ==============================================
    // HANDLE CHANGE - CRIAÇÃO
    // ==============================================
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === 'armazemId') {
            console.log('🏠 [handleChange] Armazém selecionado:', value);
        }

        if (name.startsWith('impostos.')) {
            const field = name.split('.')[1];

            if (field === 'iva') {
                const val = value === '' ? null : value;
                setFormData(prev => ({
                    ...prev,
                    impostos: { ...prev.impostos, [field]: val }
                }));
            } else if (field === 'usarIvaEmpresa') {
                setFormData(prev => ({
                    ...prev,
                    impostos: {
                        ...prev.impostos,
                        [field]: checked,
                        iva: checked ? null : prev.impostos.iva
                    }
                }));
            } else {
                const val = type === 'checkbox' ? checked : value;
                setFormData(prev => ({
                    ...prev,
                    impostos: { ...prev.impostos, [field]: val }
                }));
            }
        } else if (name === 'precoUnitario') {
            // 🔥 SANITIZA O VALOR (REMOVE VÍRGULAS E CARACTERES ESPECIAIS)
            const val = sanitizarPreco(value);
            setFormData(prev => ({
                ...prev,
                [name]: val
            }));
        } else if (name === 'precoVenda') {
            // 🔥 O PRECO VENDA É CALCULADO AUTOMATICAMENTE, MAS PERMITIMOS EDIÇÃO MANUAL
            const val = sanitizarPreco(value);
            setFormData(prev => ({
                ...prev,
                [name]: val
            }));
        } else {
            const val = type === 'checkbox' ? checked : value;
            setFormData(prev => ({ ...prev, [name]: val }));
        }
    };

    // ==============================================
    // HANDLE CHANGE - EDIÇÃO
    // ==============================================
    const handleEditChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === 'armazemId') {
            console.log('🏠 [handleEditChange] Armazém selecionado na edição:', value);
        }

        if (name.startsWith('impostos.')) {
            const field = name.split('.')[1];

            if (field === 'iva') {
                const val = value === '' ? null : value;
                setEditFormData(prev => ({
                    ...prev,
                    impostos: { ...prev.impostos, [field]: val }
                }));
            } else if (field === 'usarIvaEmpresa') {
                setEditFormData(prev => ({
                    ...prev,
                    impostos: {
                        ...prev.impostos,
                        [field]: checked,
                        iva: checked ? null : prev.impostos.iva
                    }
                }));
            } else {
                const val = type === 'checkbox' ? checked : value;
                setEditFormData(prev => ({
                    ...prev,
                    impostos: { ...prev.impostos, [field]: val }
                }));
            }
        } else if (name === 'precoUnitario') {
            const val = sanitizarPreco(value);
            setEditFormData(prev => ({
                ...prev,
                [name]: val
            }));
        } else if (name === 'precoVenda') {
            const val = sanitizarPreco(value);
            setEditFormData(prev => ({
                ...prev,
                [name]: val
            }));
        } else {
            const val = type === 'checkbox' ? checked : value;
            setEditFormData(prev => ({ ...prev, [name]: val }));
        }
    };

    // ==============================================
    // 🔥 HANDLE CHANGE - STOCK FORM
    // ==============================================
    const handleStockChange = (e) => {
        const { name, value } = e.target;
        console.log(`📝 [handleStockChange] ${name} = ${value}`);
        setStockFormData(prev => {
            const novoState = { ...prev, [name]: value };
            console.log('📝 Novo stockFormData:', novoState);
            return novoState;
        });
    };

    // ==============================================
    // FUNÇÕES DE PAGINAÇÃO DO HISTÓRICO
    // ==============================================
    const getCurrentPageHistorico = () => {
        if (!produtoDetalhes || !produtoDetalhes.historicoEntradas) return [];
        const startIndex = (historicoPagination.page - 1) * historicoPagination.limit;
        const endIndex = startIndex + historicoPagination.limit;
        return produtoDetalhes.historicoEntradas.slice(startIndex, endIndex);
    };

    const goToHistoricoPage = (page) => {
        if (page < 1 || page > historicoPagination.pages) return;
        setHistoricoPagination(prev => ({ ...prev, page }));
    };

    const renderHistoricoPagination = () => {
        const { page, pages, total, limit } = historicoPagination;
        if (pages <= 1) return null;

        const startItem = (page - 1) * limit + 1;
        const endItem = Math.min(page * limit, total);

        const renderPageNumbers = () => {
            if (pages <= 5) {
                return Array.from({ length: pages }, (_, i) => i + 1);
            }

            const numbers = [];
            numbers.push(1, 2);

            let start = Math.max(3, page - 1);
            let end = Math.min(pages - 2, page + 1);

            if (page <= 3) {
                start = 3;
                end = 4;
            }
            if (page >= pages - 2) {
                start = pages - 3;
                end = pages - 2;
            }

            if (start > 3) {
                numbers.push('...');
            }

            for (let i = start; i <= end; i++) {
                numbers.push(i);
            }

            if (end < pages - 2) {
                numbers.push('...');
            }

            numbers.push(pages - 1, pages);

            return numbers;
        };

        return (
            <div className="historico-pagination" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.6rem 0.8rem',
                borderTop: '1px solid var(--color-border)',
                flexWrap: 'wrap',
                gap: '0.5rem',
                marginTop: '0.5rem'
            }}>
                <div className="pagination-info" style={{ fontSize: '0.65rem', color: 'var(--color-info-dark)' }}>
                    <span>Mostrando {startItem} - {endItem} de {total} registos</span>
                </div>
                <div className="pagination-controls" style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
                    <button
                        className="pagination-btn"
                        onClick={() => goToHistoricoPage(page - 1)}
                        disabled={page === 1}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '28px',
                            height: '28px',
                            border: '1px solid var(--color-border)',
                            borderRadius: '100px',
                            background: 'transparent',
                            color: 'var(--color-dark)',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            fontSize: '0.65rem'
                        }}
                    >
                        <Icon name="chevron_left" size={16} />
                    </button>

                    <div className="pagination-numbers" style={{ display: 'flex', alignItems: 'center', gap: '0.15rem' }}>
                        {renderPageNumbers().map((p, index) => {
                            if (p === '...') {
                                return (
                                    <span
                                        key={`ellipsis-${index}`}
                                        style={{
                                            padding: '0 0.2rem',
                                            color: 'var(--color-info-dark)',
                                            fontSize: '0.65rem',
                                            fontWeight: '600'
                                        }}
                                    >
                                        …
                                    </span>
                                );
                            }

                            return (
                                <button
                                    key={p}
                                    className={`pagination-number ${page === p ? 'active' : ''}`}
                                    onClick={() => goToHistoricoPage(p)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minWidth: '28px',
                                        height: '28px',
                                        padding: '0 0.3rem',
                                        border: page === p ? 'none' : '1px solid transparent',
                                        borderRadius: '100px',
                                        background: page === p ? 'var(--gradient-premium)' : 'transparent',
                                        color: page === p ? 'white' : 'var(--color-dark)',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        fontSize: '0.65rem',
                                        fontWeight: page === p ? '700' : '500'
                                    }}
                                >
                                    {p}
                                </button>
                            );
                        })}
                    </div>

                    <button
                        className="pagination-btn"
                        onClick={() => goToHistoricoPage(page + 1)}
                        disabled={page === pages}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '28px',
                            height: '28px',
                            border: '1px solid var(--color-border)',
                            borderRadius: '100px',
                            background: 'transparent',
                            color: 'var(--color-dark)',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            fontSize: '0.65rem'
                        }}
                    >
                        <Icon name="chevron_right" size={16} />
                    </button>
                </div>
            </div>
        );
    };

    // ==============================================
    // RESET FORM
    // ==============================================
    const resetForm = () => {
        setFormData({
            nome: '',
            descricao: '',
            codigo: '',
            precoUnitario: '',
            precoVenda: '',
            precoCompra: '',
            compraQuantidade: 0,
            stockAtual: 0,
            stockMinimo: 0,
            unidadeMedida: 'UN',
            categoriaId: '',
            armazemId: '',
            ativo: true,
            impostos: {
                iva: null,
                ispc: 0,
                usarIvaEmpresa: true
            }
        });
        setStockFormData({
            quantidade: 1,
            precoUnitario: 0,
            fornecedorId: '',
            notaFiscal: '',
            observacao: ''
        });
        setCreateMessage({ text: '', type: '' });
        setActiveTab('geral');
    };

    const resetEditForm = () => {
        setEditFormData(null);
        setEditMessage({ text: '', type: '' });
        setEditActiveTab('geral');
    };

    // ==============================================
    // 🔥 CRIAÇÃO
    // ==============================================
    const handleCreateSubmit = async (e) => {
        e.preventDefault();
        setCreateLoading(true);
        setCreateMessage({ text: '', type: '' });

        console.log('📦 [handleCreateSubmit] stockFormData.fornecedorId:', stockFormData.fornecedorId);

        if (!formData.nome.trim()) {
            setCreateMessage({ text: 'O nome do produto é obrigatório', type: 'danger' });
            setCreateLoading(false);
            return;
        }

        // 🔥 O preço de venda já vem com IVA incluído (calculado pelo useEffect)
        if (!formData.precoVenda || parseFloat(formData.precoVenda) <= 0) {
            setCreateMessage({ text: 'Preço de venda inválido', type: 'danger' });
            setCreateLoading(false);
            return;
        }

        let empresaParaEnviar = empresaId;
        if (!empresaParaEnviar && loggedUser) {
            empresaParaEnviar = obterEmpresaIdDoUtilizador(loggedUser);
        }

        if (!empresaParaEnviar) {
            setCreateMessage({
                text: 'Utilizador sem empresa associada. Contacte o administrador.',
                type: 'danger'
            });
            setCreateLoading(false);
            return;
        }

        const stockQuantidade = parseInt(stockFormData.quantidade) || 0;
        const stockPreco = parseFloat(stockFormData.precoUnitario) || 0;
        const quantidadeInicial = parseInt(formData.compraQuantidade) || 0;
        const precoCompraInicial = parseFloat(formData.precoCompra) || 0;

        let quantidadeFinal = 0;
        let precoFinal = 0;
        let historicoEntradas = [];

        const fornecedorId = stockFormData.fornecedorId || null;
        console.log('📦 [handleCreateSubmit] fornecedorId final:', fornecedorId);

        if (stockQuantidade > 0 && stockPreco > 0) {
            quantidadeFinal = stockQuantidade;
            precoFinal = stockPreco;
            historicoEntradas = [{
                quantidade: stockQuantidade,
                precoUnitario: stockPreco,
                fornecedorId: fornecedorId,
                dataEntrada: new Date().toISOString(),
                observacao: stockFormData.observacao || 'Entrada inicial na criação do produto',
                criadoPor: loggedUser?._id || loggedUser?.id || null,
                notaFiscal: stockFormData.notaFiscal || null
            }];
        } else if (quantidadeInicial > 0) {
            quantidadeFinal = quantidadeInicial;
            precoFinal = precoCompraInicial;
            historicoEntradas = [{
                quantidade: quantidadeInicial,
                precoUnitario: precoCompraInicial,
                fornecedorId: fornecedorId,
                dataEntrada: new Date().toISOString(),
                observacao: 'Entrada inicial na criação do produto',
                criadoPor: loggedUser?._id || loggedUser?.id || null
            }];
        }

        // 🔥 O precoVenda já está com IVA incluído
        const dadosParaEnviar = {
            nome: formData.nome.trim(),
            descricao: formData.descricao?.trim() || '',
            codigo: formData.codigo?.trim() || '',
            precoVenda: parseFloat(formData.precoVenda) || 0,
            precoCompra: precoFinal,
            compraQuantidade: quantidadeFinal,
            stockAtual: quantidadeFinal,
            stockMinimo: parseInt(formData.stockMinimo) || 0,
            unidadeMedida: formData.unidadeMedida || 'UN',
            categoriaId: formData.categoriaId || null,
            fornecedorId: fornecedorId,
            armazemId: formData.armazemId || null,
            empresaId: empresaParaEnviar,
            ativo: formData.ativo !== undefined ? formData.ativo : true,
            impostos: {
                iva: formData.impostos.iva !== '' && formData.impostos.iva !== null ? parseFloat(formData.impostos.iva) : null,
                ispc: parseFloat(formData.impostos.ispc) || 0,
                usarIvaEmpresa: formData.impostos.usarIvaEmpresa
            },
            historicoEntradas: historicoEntradas
        };

        console.log('📦 Enviando produto com preço com IVA:', dadosParaEnviar.precoVenda);

        try {
            const response = await api.post('/produtos', dadosParaEnviar);

            if (response.data) {
                console.log('✅ Produto criado com sucesso:', response.data);
                setCreateMessage({ text: 'Produto criado com sucesso!', type: 'success' });
                setTimeout(() => {
                    setShowCreateModal(false);
                    resetForm();
                    fetchProdutos();
                }, 1500);
            }
        } catch (err) {
            console.error('❌ Erro ao criar produto:', err);
            setCreateMessage({
                text: err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao criar produto',
                type: 'danger'
            });
        } finally {
            setCreateLoading(false);
        }
    };

    // ==============================================
    // VER DETALHES
    // ==============================================
    const verDetalhes = async (produto) => {
        try {
            setShowEditModal(false);
            setEditFormData(null);

            const response = await api.get(`/produtos/${produto._id}`);
            const produtoCompleto = response.data.data || produto;
            setProdutoDetalhes(produtoCompleto);
            setDetailsActiveTab('dados');

            setHistoricoPagination(prev => ({
                ...prev,
                page: 1
            }));

            setTimeout(() => {
                setShowDetailsModal(true);
            }, 100);

        } catch (err) {
            console.error('❌ Erro ao buscar detalhes:', err);
            setProdutoDetalhes(produto);
            setShowDetailsModal(true);
        }
    };

    // ==============================================
    // CARREGAR PRODUTO PARA EDIÇÃO
    // ==============================================
    const loadProdutoForEdit = async (produto) => {
        setEditLoading(true);
        try {
            setShowDetailsModal(false);
            setProdutoDetalhes(null);

            const response = await api.get(`/produtos/${produto._id}`);
            const produtoCompleto = response.data.data || produto;

            let armazemId = '';
            if (produtoCompleto.armazemId) {
                if (typeof produtoCompleto.armazemId === 'object' && produtoCompleto.armazemId._id) {
                    armazemId = produtoCompleto.armazemId._id;
                } else if (typeof produtoCompleto.armazemId === 'string') {
                    armazemId = produtoCompleto.armazemId;
                } else if (produtoCompleto.armazemId._id) {
                    armazemId = produtoCompleto.armazemId._id;
                }
            }

            let fornecedorId = '';
            if (produtoCompleto.fornecedorId) {
                if (typeof produtoCompleto.fornecedorId === 'object' && produtoCompleto.fornecedorId._id) {
                    fornecedorId = produtoCompleto.fornecedorId._id;
                } else if (typeof produtoCompleto.fornecedorId === 'string') {
                    fornecedorId = produtoCompleto.fornecedorId;
                }
            }

            // 🔥 CALCULA O PREÇO UNITÁRIO (SEM IVA) A PARTIR DO PREÇO DE VENDA
            const ivaEfetivo = getIvaEfetivo(produtoCompleto.impostos);
            const precoVenda = parseFloat(produtoCompleto.precoVenda) || 0;
            let precoUnitario = precoVenda;

            if (ivaEfetivo !== null && ivaEfetivo !== undefined && precoVenda > 0) {
                const precoSemIva = calcularPrecoSemIVA(precoVenda, ivaEfetivo);
                if (precoSemIva !== null) {
                    precoUnitario = precoSemIva;
                }
            }

            setEditFormData({
                _id: produtoCompleto._id,
                nome: produtoCompleto.nome || '',
                descricao: produtoCompleto.descricao || '',
                codigo: produtoCompleto.codigo || '',
                precoUnitario: precoUnitario > 0 ? Math.round(precoUnitario * 100) / 100 : '',
                precoVenda: produtoCompleto.precoVenda || '',
                precoCompra: produtoCompleto.precoCompra || '',
                compraQuantidade: produtoCompleto.compraQuantidade || 0,
                stockAtual: produtoCompleto.stockAtual || 0,
                stockMinimo: produtoCompleto.stockMinimo || 0,
                unidadeMedida: produtoCompleto.unidadeMedida || 'UN',
                categoriaId: produtoCompleto.categoriaId?._id || produtoCompleto.categoriaId || '',
                fornecedorId: fornecedorId,
                armazemId: armazemId,
                ativo: produtoCompleto.ativo !== undefined ? produtoCompleto.ativo : true,
                impostos: {
                    iva: produtoCompleto.impostos?.iva || null,
                    ispc: produtoCompleto.impostos?.ispc || 0,
                    usarIvaEmpresa: produtoCompleto.impostos?.usarIvaEmpresa !== undefined ?
                        produtoCompleto.impostos.usarIvaEmpresa : true
                },
                historicoEntradas: produtoCompleto.historicoEntradas || []
            });

            setEditActiveTab('geral');

            setTimeout(() => {
                setShowEditModal(true);
            }, 100);

        } catch (error) {
            console.error('Erro ao carregar produto:', error);
            setEditMessage({ text: 'Erro ao carregar dados do produto', type: 'danger' });
        } finally {
            setEditLoading(false);
        }
    };

    const handleEdit = (produto) => {
        loadProdutoForEdit(produto);
    };

    // ==============================================
    // 🔥 EDIÇÃO
    // ==============================================
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setEditLoading(true);
        setEditMessage({ text: '', type: '' });

        if (!editFormData.nome.trim()) {
            setEditMessage({ text: 'O nome do produto é obrigatório', type: 'danger' });
            setEditLoading(false);
            return;
        }

        // 🔥 O preço de venda já vem com IVA incluído
        if (!editFormData.precoVenda || parseFloat(editFormData.precoVenda) <= 0) {
            setEditMessage({ text: 'Preço de venda inválido', type: 'danger' });
            setEditLoading(false);
            return;
        }

        try {
            const { _id, ...updateData } = editFormData;

            if (updateData.stockAtual !== undefined) {
                const produtoOriginal = await api.get(`/produtos/${_id}`);
                const stockOriginal = produtoOriginal.data?.data?.stockAtual || 0;
                const diff = updateData.stockAtual - stockOriginal;

                if (diff > 0) {
                    if (!updateData.historicoEntradas) {
                        updateData.historicoEntradas = [];
                    }
                    const fornecedorId = updateData.fornecedorId || null;
                    updateData.historicoEntradas.push({
                        quantidade: diff,
                        precoUnitario: parseFloat(updateData.precoCompra) || 0,
                        fornecedorId: fornecedorId,
                        dataEntrada: new Date().toISOString(),
                        observacao: `Ajuste de stock via edição (+${diff} unidades)`,
                        criadoPor: loggedUser?._id || loggedUser?.id || null
                    });
                }
            }

            console.log('📦 Enviando updateData com preço com IVA:', updateData.precoVenda);

            const response = await api.put(`/produtos/${_id}`, updateData);

            if (response.data) {
                setEditMessage({ text: 'Produto atualizado com sucesso!', type: 'success' });
                setTimeout(() => {
                    setShowEditModal(false);
                    resetEditForm();
                    fetchProdutos();
                }, 1500);
            }
        } catch (err) {
            console.error('❌ Erro ao atualizar produto:', err);
            setEditMessage({
                text: err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao atualizar produto',
                type: 'danger'
            });
        } finally {
            setEditLoading(false);
        }
    };

    // ==============================================
    // EXCLUSÃO
    // ==============================================
    const openDeleteModal = (produto) => {
        setProdutoToDelete(produto);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setProdutoToDelete(null);
    };

    const confirmDelete = async () => {
        if (!produtoToDelete) return;

        try {
            const response = await api.delete(`/produtos/${produtoToDelete._id}`);
            if (response.data) {
                showTempToast('Sucesso', `Produto "${produtoToDelete.nome}" removido com sucesso!`, 'success');
                closeDeleteModal();
                fetchProdutos();
            }
        } catch (err) {
            console.error('❌ Erro ao remover produto:', err);
            showTempToast('Erro', err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao remover produto', 'danger');
        }
    };

    // ==============================================
    // EXPORTAÇÃO
    // ==============================================
    const exportarProdutos = async (formato) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada. Faça login novamente.', 'danger');
                return;
            }

            const params = new URLSearchParams();
            params.append('formato', formato);
            if (searchTerm) params.append('search', searchTerm);
            if (filtros.categoria && filtros.categoria !== 'todos') params.append('categoria', filtros.categoria);
            if (filtros.fornecedor && filtros.fornecedor !== 'todos') params.append('fornecedor', filtros.fornecedor);
            if (filtros.statusStock && filtros.statusStock !== 'todos') params.append('statusStock', filtros.statusStock);
            if (filtros.unidadeMedida && filtros.unidadeMedida !== 'todos') params.append('unidadeMedida', filtros.unidadeMedida);
            if (filtros.ativo && filtros.ativo !== 'todos') params.append('ativo', filtros.ativo);

            const url = `/api/produtos/exportar?${params.toString()}`;
            console.log('📤 Exportando produtos para:', url);

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.erro || 'Erro na exportação');
            }

            const blob = await response.blob();
            const extensao = formato === 'excel' || formato === 'xlsx' ? 'xlsx' : 'csv';

            const urlDownload = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlDownload;
            link.download = `produtos_${new Date().toISOString().split('T')[0]}.${extensao}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlDownload);

            showTempToast('Sucesso', `Produtos exportados em ${formato.toUpperCase()}`, 'success');
        } catch (err) {
            console.error('❌ Erro na exportação:', err);
            showTempToast('Erro', err.message || 'Falha na exportação', 'danger');
        }
    };

    // ==============================================
    // PAGINAÇÃO
    // ==============================================
    const getCurrentPageProdutos = () => {
        const startIndex = (pagination.page - 1) * pagination.limit;
        const endIndex = startIndex + pagination.limit;
        return filteredProdutos.slice(startIndex, endIndex);
    };

    const goToPage = (page) => {
        if (page < 1 || page > pagination.pages) return;
        setPagination({ ...pagination, page });
    };

    const renderPagination = () => {
        const { page, pages, total } = pagination;
        if (pages <= 1) return null;

        const startItem = (page - 1) * pagination.limit + 1;
        const endItem = Math.min(page * pagination.limit, total);

        return (
            <div className="produtos-pagination">
                <div className="pagination-info">
                    <span>Mostrando {startItem} - {endItem} de {total} produtos</span>
                </div>
                <div className="pagination-controls">
                    <button className="pagination-btn" onClick={() => goToPage(page - 1)} disabled={page === 1}>
                        <Icon name="chevron_left" size={18} />
                    </button>
                    <div className="pagination-numbers">
                        {Array.from({ length: pages }, (_, i) => i + 1).map(p => (
                            <button
                                key={p}
                                className={`pagination-number ${page === p ? 'active' : ''}`}
                                onClick={() => goToPage(p)}
                            >
                                {p}
                            </button>
                        ))}
                    </div>
                    <button className="pagination-btn" onClick={() => goToPage(page + 1)} disabled={page === pages}>
                        <Icon name="chevron_right" size={18} />
                    </button>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER PRINCIPAL
    // ==============================================
    const currentProdutos = getCurrentPageProdutos();
    const currentHistorico = getCurrentPageHistorico();

    // 🔥 CALCULA O PREÇO COM IVA PARA EXIBIÇÃO (CRIAÇÃO)
    const precoUnitarioAtual = parseFloat(formData.precoUnitario) || 0;
    const ivaEfetivo = getIvaEfetivo(formData.impostos);
    const precoVendaCalculado = calcularPrecoComIVA(precoUnitarioAtual, ivaEfetivo);

    // 🔥 CALCULA O PREÇO COM IVA PARA EXIBIÇÃO (EDIÇÃO)
    const precoUnitarioEdit = editFormData ? parseFloat(editFormData.precoUnitario) || 0 : 0;
    const ivaEfetivoEdit = editFormData ? getIvaEfetivo(editFormData.impostos) : null;
    const precoVendaCalculadoEdit = calcularPrecoComIVA(precoUnitarioEdit, ivaEfetivoEdit);

    return (
        <div className="produtos-container">
            {/* MODAL DE CRIAÇÃO COM TABS */}
{showCreateModal && (
    <div className="produto-modal-overlay" onClick={() => { setShowCreateModal(false); resetForm(); }}>
        <div className="produto-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="produto-modal-header">
                <h3><Icon name="add_box" size={22} /> Novo Produto</h3>
                <button className="produto-modal-close" onClick={() => { setShowCreateModal(false); resetForm(); }}>×</button>
            </div>
            <div className="produto-modal-body">
                {createMessage.text && (
                    <div className={`produto-modal-alert produto-modal-alert-${createMessage.type}`}>
                        <Icon name={createMessage.type === 'success' ? 'check_circle' : 'error'} size={18} />
                        <span>{createMessage.text}</span>
                        <button className="produto-alert-close" onClick={() => setCreateMessage({ text: '', type: '' })}>×</button>
                    </div>
                )}
                <form onSubmit={handleCreateSubmit}>
                    <div className="produto-modal-tabs">
                        <button type="button" className={`produto-modal-tab-btn ${activeTab === 'geral' ? 'active' : ''}`} onClick={() => setActiveTab('geral')}>
                            <Icon name="info" size={16} />
                            <span className="produto-tab-label">Dados Gerais</span>
                        </button>
                        <button type="button" className={`produto-modal-tab-btn ${activeTab === 'impostos' ? 'active' : ''}`} onClick={() => setActiveTab('impostos')}>
                            <Icon name="receipt" size={16} />
                            <span className="produto-tab-label">Impostos</span>
                        </button>
                        <button type="button" className={`produto-modal-tab-btn ${activeTab === 'stock' ? 'active' : ''}`} onClick={() => setActiveTab('stock')}>
                            <Icon name="inventory_2" size={16} />
                            <span className="produto-tab-label">Entrada de Stock</span>
                        </button>
                    </div>

                    {/* TAB DADOS GERAIS */}
                    <div className={`produto-modal-tab-panel ${activeTab === 'geral' ? 'active' : ''}`}>
                        <div className="produto-modal-section">
                            <div className="produto-form-group">
                                <label>Nome <span className="produto-required">*</span></label>
                                <input type="text" name="nome" value={formData.nome} onChange={handleChange} required placeholder="Nome do produto" />
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Código</label>
                                    <input type="text" name="codigo" value={formData.codigo} onChange={handleChange} placeholder="Código (opcional)" />
                                </div>
                                <div className="produto-form-group">
                                    <label>Categoria</label>
                                    <select name="categoriaId" value={formData.categoriaId} onChange={handleChange}>
                                        <option value="">Selecione uma categoria</option>
                                        {categorias.map(cat => (
                                            <option key={cat._id} value={cat._id}>{cat.nome}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Armazém</label>
                                    <select name="armazemId" value={formData.armazemId} onChange={handleChange}>
                                        <option value="">Selecione um armazém</option>
                                        {armazens.map(arm => (
                                            <option key={arm._id} value={arm._id}>
                                                {arm.nome} {arm.codigo ? `(${arm.codigo})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                    <small className="produto-form-help">Armazém onde o produto será armazenado</small>
                                </div>
                                <div className="produto-form-group">
                                    <label>Preço Unitário <span className="produto-required">*</span></label>
                                    <input
                                        type="text"
                                        name="precoUnitario"
                                        value={formData.precoUnitario}
                                        onChange={handleChange}
                                        required
                                        placeholder="0.00"
                                        inputMode="decimal"
                                        autoComplete="off"
                                    />
                                    <small className="produto-form-help">Preço base sem IVA</small>
                                </div>
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Preço de Venda (com IVA)</label>
                                    <input
                                        type="text"
                                        name="precoVenda"
                                        value={formData.precoVenda}
                                        onChange={handleChange}
                                        placeholder="0.00"
                                        inputMode="decimal"
                                        autoComplete="off"
                                        readOnly
                                        
                                    />
                                    {ivaEfetivo !== null && ivaEfetivo !== undefined && precoUnitarioAtual > 0 && (
                                        <small className="produto-form-help produto-help-info">
                                            <Icon name="info" size={12} style={{ marginRight: '0.3rem' }} />
                                            Calculado com IVA de {ivaEfetivo}% (base: {formatarMoeda(precoUnitarioAtual)})
                                        </small>
                                    )}
                                    {ivaEfetivo === null && precoUnitarioAtual > 0 && (
                                        <small className="produto-form-help produto-help-warning">
                                            <Icon name="warning" size={12} style={{ marginRight: '0.3rem' }} />
                                            Sem IVA configurado
                                        </small>
                                    )}
                                </div>
                                <div className="produto-form-group">
                                    <label>Preço de Compra</label>
                                    <input type="number" name="precoCompra" value={formData.precoCompra} onChange={handleChange} placeholder="0.00" step="0.01" min="0" />
                                </div>
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Stock Mínimo</label>
                                    <input type="number" name="stockMinimo" value={formData.stockMinimo} onChange={handleChange} placeholder="0" min="0" />
                                </div>
                                <div className="produto-form-group">
                                    <label>Unidade de Medida</label>
                                    <select name="unidadeMedida" value={formData.unidadeMedida} onChange={handleChange}>
                                        {UNIDADES_MEDIDA.map(u => (
                                            <option key={u.value} value={u.value}>{u.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="produto-form-group">
                                <label>Descrição</label>
                                <textarea name="descricao" value={formData.descricao} onChange={handleChange} placeholder="Descrição do produto" rows="2" />
                            </div>
                            <div className="produto-form-group-check">
                                <label className="produto-checkbox-label">
                                    <input type="checkbox" name="ativo" checked={formData.ativo} onChange={handleChange} />
                                    Produto Ativo
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* TAB IMPOSTOS */}
                    <div className={`produto-modal-tab-panel ${activeTab === 'impostos' ? 'active' : ''}`}>
                        <div className="produto-modal-section">
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>IVA (%)</label>
                                    <input
                                        type="number"
                                        name="impostos.iva"
                                        value={formData.impostos.iva || ''}
                                        onChange={handleChange}
                                        placeholder="Deixar em branco para usar o da empresa"
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        disabled={formData.impostos.usarIvaEmpresa}
                                    />
                                    <small className="produto-form-help">{formData.impostos.usarIvaEmpresa ? 'Usando IVA da empresa' : 'IVA específico do produto'}</small>
                                </div>
                                <div className="produto-form-group">
                                    <label>ISPC (%)</label>
                                    <input type="number" name="impostos.ispc" value={formData.impostos.ispc || 0} onChange={handleChange} placeholder="0" step="0.01" min="0" max="100" />
                                </div>
                            </div>
                            <div className="produto-form-group-check">
                                <label className="produto-checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="impostos.usarIvaEmpresa"
                                        checked={formData.impostos.usarIvaEmpresa}
                                        onChange={handleChange}
                                    />
                                    Usar IVA da empresa
                                    ({configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? `${configEmpresa.iva}%` : 'N/D'})
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* TAB ENTRADA DE STOCK */}
                    <div className={`produto-modal-tab-panel ${activeTab === 'stock' ? 'active' : ''}`}>
                        <div className="produto-modal-section">
                            <div className="produto-stock-info-box">
                                <p>
                                    <Icon name="info" size={14} style={{ marginRight: '0.5rem' }} />
                                    Preencha os campos abaixo para registrar a entrada inicial de stock deste produto.
                                    A data da entrada será registada automaticamente no momento da criação.
                                </p>
                            </div>

                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Quantidade <span className="produto-required">*</span></label>
                                    <input
                                        type="number"
                                        name="quantidade"
                                        value={stockFormData.quantidade}
                                        onChange={handleStockChange}
                                        min="1"
                                        step="1"
                                        placeholder="1"
                                    />
                                    <small className="produto-form-help">Quantidade a adicionar ao stock</small>
                                </div>
                                <div className="produto-form-group">
                                    <label>Preço Unitário <span className="produto-required">*</span></label>
                                    <input
                                        type="number"
                                        name="precoUnitario"
                                        value={stockFormData.precoUnitario}
                                        onChange={handleStockChange}
                                        min="0.01"
                                        step="0.01"
                                        placeholder="0.00"
                                    />
                                    <small className="produto-form-help">Preço de compra por unidade</small>
                                </div>
                            </div>

                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Fornecedor</label>
                                    <select
                                        name="fornecedorId"
                                        value={stockFormData.fornecedorId || ''}
                                        onChange={handleStockChange}
                                    >
                                        <option value="">Selecione um fornecedor</option>
                                        {fornecedores.map(f => (
                                            <option key={f._id} value={f._id}>{f.nome}</option>
                                        ))}
                                    </select>
                                    <small className="produto-form-help">Fornecedor da entrada de stock</small>
                                </div>
                                <div className="produto-form-group">
                                    <label>Nº Nota Fiscal</label>
                                    <input
                                        type="text"
                                        name="notaFiscal"
                                        value={stockFormData.notaFiscal || ''}
                                        onChange={handleStockChange}
                                        placeholder="Número da nota fiscal (opcional)"
                                    />
                                </div>
                            </div>

                            <div className="produto-form-group-observacoes">
                                <label>Observação</label>
                                <textarea
                                    name="observacao"
                                    value={stockFormData.observacao || ''}
                                    onChange={handleStockChange}
                                    placeholder="Observações adicionais (opcional)"
                                    rows="2"
                                    
                                />
                            </div>
                        </div>
                    </div>

                    <div className="produto-modal-actions">
                        <button type="submit" className="produto-modal-btn-primary" disabled={createLoading}>
                            {createLoading ? 'A criar...' : 'Criar Produto'}
                        </button>
                        <button type="button" className="produto-modal-btn-secondary" onClick={resetForm}>Limpar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
)}

{/* MODAL DE EDIÇÃO COM TABS */}
{showEditModal && editFormData && (
    <div className="produto-modal-overlay" onClick={() => { setShowEditModal(false); resetEditForm(); }}>
        <div className="produto-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="produto-modal-header">
                <h3><Icon name="edit" size={22} /> Editar Produto</h3>
                <button className="produto-modal-close" onClick={() => { setShowEditModal(false); resetEditForm(); }}>×</button>
            </div>
            <div className="produto-modal-body">
                {editMessage.text && (
                    <div className={`produto-modal-alert produto-modal-alert-${editMessage.type}`}>
                        <Icon name={editMessage.type === 'success' ? 'check_circle' : 'error'} size={18} />
                        <span>{editMessage.text}</span>
                        <button className="produto-alert-close" onClick={() => setEditMessage({ text: '', type: '' })}>×</button>
                    </div>
                )}
                <form onSubmit={handleEditSubmit}>
                    <div className="produto-modal-tabs">
                        <button type="button" className={`produto-modal-tab-btn ${editActiveTab === 'geral' ? 'active' : ''}`} onClick={() => setEditActiveTab('geral')}>
                            <Icon name="info" size={16} />
                            <span className="produto-tab-label">Dados Gerais</span>
                        </button>
                        <button type="button" className={`produto-modal-tab-btn ${editActiveTab === 'impostos' ? 'active' : ''}`} onClick={() => setEditActiveTab('impostos')}>
                            <Icon name="receipt" size={16} />
                            <span className="produto-tab-label">Impostos</span>
                        </button>
                    </div>

                    <div className={`produto-modal-tab-panel ${editActiveTab === 'geral' ? 'active' : ''}`}>
                        <div className="produto-modal-section">
                            <div className="produto-form-group">
                                <label>Nome <span className="produto-required">*</span></label>
                                <input type="text" name="nome" value={editFormData.nome} onChange={handleEditChange} required placeholder="Nome do produto" />
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Código</label>
                                    <input type="text" name="codigo" value={editFormData.codigo} onChange={handleEditChange} placeholder="Código" disabled />
                                </div>
                                <div className="produto-form-group">
                                    <label>Categoria</label>
                                    <select name="categoriaId" value={editFormData.categoriaId} onChange={handleEditChange}>
                                        <option value="">Selecione uma categoria</option>
                                        {categorias.map(cat => (
                                            <option key={cat._id} value={cat._id}>{cat.nome}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Armazém</label>
                                    <select
                                        name="armazemId"
                                        value={(() => {
                                            if (!editFormData) return '';
                                            if (editFormData.armazemId && typeof editFormData.armazemId === 'object' && editFormData.armazemId._id) {
                                                return editFormData.armazemId._id;
                                            }
                                            if (typeof editFormData.armazemId === 'string') {
                                                return editFormData.armazemId;
                                            }
                                            return '';
                                        })()}
                                        onChange={handleEditChange}
                                    >
                                        <option value="">Selecione um armazém</option>
                                        {armazens.map(arm => (
                                            <option key={arm._id} value={arm._id}>
                                                {arm.nome} {arm.codigo ? `(${arm.codigo})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                    <small className="produto-form-help">Armazém onde o produto está armazenado</small>
                                </div>
                                <div className="produto-form-group">
                                    <label>Preço Unitário <span className="produto-required">*</span></label>
                                    <input
                                        type="text"
                                        name="precoUnitario"
                                        value={editFormData.precoUnitario}
                                        onChange={handleEditChange}
                                        required
                                        placeholder="0.00"
                                        inputMode="decimal"
                                        autoComplete="off"
                                    />
                                    <small className="produto-form-help">Preço base sem IVA</small>
                                </div>
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Preço de Venda (com IVA)</label>
                                    <input
                                        type="text"
                                        name="precoVenda"
                                        value={editFormData.precoVenda}
                                        onChange={handleEditChange}
                                        placeholder="0.00"
                                        inputMode="decimal"
                                        autoComplete="off"
                                        readOnly
                                        
                                    />
                                    {ivaEfetivoEdit !== null && ivaEfetivoEdit !== undefined && precoUnitarioEdit > 0 && (
                                        <small className="produto-form-help produto-help-info">
                                            <Icon name="info" size={12} style={{ marginRight: '0.3rem' }} />
                                            Calculado com IVA de {ivaEfetivoEdit}% (base: {formatarMoeda(precoUnitarioEdit)})
                                        </small>
                                    )}
                                    {ivaEfetivoEdit === null && precoUnitarioEdit > 0 && (
                                        <small className="produto-form-help produto-help-warning">
                                            <Icon name="warning" size={12} style={{ marginRight: '0.3rem' }} />
                                            Sem IVA configurado
                                        </small>
                                    )}
                                </div>
                                <div className="produto-form-group">
                                    <label>Preço de Compra</label>
                                    <input type="number" name="precoCompra" value={editFormData.precoCompra} onChange={handleEditChange} placeholder="0.00" step="0.01" min="0" />
                                </div>
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Stock Mínimo</label>
                                    <input type="number" name="stockMinimo" value={editFormData.stockMinimo} onChange={handleEditChange} placeholder="0" min="0" />
                                </div>
                                <div className="produto-form-group">
                                    <label>Unidade de Medida</label>
                                    <select name="unidadeMedida" value={editFormData.unidadeMedida} onChange={handleEditChange}>
                                        {UNIDADES_MEDIDA.map(u => (
                                            <option key={u.value} value={u.value}>{u.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>Fornecedor</label>
                                    <select name="fornecedorId" value={editFormData.fornecedorId || ''} onChange={handleEditChange}>
                                        <option value="">Selecione um fornecedor</option>
                                        {fornecedores.map(f => (
                                            <option key={f._id} value={f._id}>{f.nome}</option>
                                        ))}
                                    </select>
                                    <small className="produto-form-help">Fornecedor principal do produto</small>
                                </div>
                                <div className="produto-form-group">
                                    {/* Espaço vazio */}
                                </div>
                            </div>
                            <div className="produto-form-group">
                                <label>Descrição</label>
                                <textarea name="descricao" value={editFormData.descricao} onChange={handleEditChange} placeholder="Descrição do produto" rows="2" />
                            </div>
                            <div className="produto-form-group-check">
                                <label className="produto-checkbox-label">
                                    <input type="checkbox" name="ativo" checked={editFormData.ativo} onChange={handleEditChange} />
                                    Produto Ativo
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* TAB IMPOSTOS */}
                    <div className={`produto-modal-tab-panel ${editActiveTab === 'impostos' ? 'active' : ''}`}>
                        <div className="produto-modal-section">
                            <div className="produto-form-row">
                                <div className="produto-form-group">
                                    <label>IVA (%)</label>
                                    <input
                                        type="number"
                                        name="impostos.iva"
                                        value={editFormData.impostos.iva || ''}
                                        onChange={handleEditChange}
                                        placeholder="Deixar em branco para usar o da empresa"
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        disabled={editFormData.impostos.usarIvaEmpresa}
                                    />
                                    <small className="produto-form-help">{editFormData.impostos.usarIvaEmpresa ? 'Usando IVA da empresa' : 'IVA específico do produto'}</small>
                                </div>
                                <div className="produto-form-group">
                                    <label>ISPC (%)</label>
                                    <input type="number" name="impostos.ispc" value={editFormData.impostos.ispc || 0} onChange={handleEditChange} placeholder="0" step="0.01" min="0" max="100" />
                                </div>
                            </div>
                            <div className="produto-form-group-check">
                                <label className="produto-checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="impostos.usarIvaEmpresa"
                                        checked={editFormData.impostos.usarIvaEmpresa}
                                        onChange={handleEditChange}
                                    />
                                    Usar IVA da empresa
                                    ({configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? `${configEmpresa.iva}%` : 'N/D'})
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="produto-modal-actions">
                        <button type="submit" className="produto-modal-btn-primary" disabled={editLoading}>
                            {editLoading ? 'A atualizar...' : 'Salvar Alterações'}
                        </button>
                        <button type="button" className="produto-modal-btn-secondary" onClick={() => { setShowEditModal(false); resetEditForm(); }}>Cancelar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
)}

{/* MODAL DE DETALHES */}
{showDetailsModal && produtoDetalhes && (
    <div className="produto-modal-overlay" onClick={() => setShowDetailsModal(false)}>
        <div className="produto-modal-content produto-modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="produto-modal-header">
                <h3>
                    <Icon name="inventory_2" size={22} />
                    {produtoDetalhes.nome}
                    {!produtoDetalhes.ativo && (
                        <span className="produto-status-badge inactive" style={{ marginLeft: '0.5rem' }}>
                            <Icon name="block" size={12} /> Inativo
                        </span>
                    )}
                </h3>
                <button className="produto-modal-close" onClick={() => setShowDetailsModal(false)}>×</button>
            </div>
            <div className="produto-modal-body">
                {/* TABS DO DETALHES */}
                <div className="produto-modal-tabs">
                    <button type="button" className={`produto-modal-tab-btn ${detailsActiveTab === 'dados' ? 'active' : ''}`} onClick={() => setDetailsActiveTab('dados')}>
                        <Icon name="info" size={16} />
                        <span className="produto-tab-label">Dados</span>
                    </button>
                    <button type="button" className={`produto-modal-tab-btn ${detailsActiveTab === 'graficos' ? 'active' : ''}`} onClick={() => setDetailsActiveTab('graficos')}>
                        <Icon name="trending_up" size={16} />
                        <span className="produto-tab-label">Gráficos</span>
                    </button>
                    <button type="button" className={`produto-modal-tab-btn ${detailsActiveTab === 'impostos' ? 'active' : ''}`} onClick={() => setDetailsActiveTab('impostos')}>
                        <Icon name="receipt" size={16} />
                        <span className="produto-tab-label">Impostos</span>
                    </button>
                    <button type="button" className={`produto-modal-tab-btn ${detailsActiveTab === 'historico' ? 'active' : ''}`} onClick={() => setDetailsActiveTab('historico')}>
                        <Icon name="history" size={16} />
                        <span className="produto-tab-label">Histórico</span>
                    </button>
                </div>

                {/* TAB DADOS */}
                <div className={`produto-modal-tab-panel ${detailsActiveTab === 'dados' ? 'active' : ''}`}>
                    <div className="produto-detalhes-grid">
                        <div className="produto-info-item">
                            <span className="produto-label">📌 Código</span>
                            <span className="produto-value">{produtoDetalhes.codigo || '-'}</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">📂 Categoria</span>
                            <span className="produto-value">{produtoDetalhes.categoriaId?.nome || '-'}</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">🏢 Fornecedor</span>
                            <span className="produto-value">{produtoDetalhes.fornecedorId?.nome || '-'}</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">🏠 Armazém</span>
                            <span className="produto-value">
                                {(() => {
                                    if (produtoDetalhes.armazemId && typeof produtoDetalhes.armazemId === 'object' && produtoDetalhes.armazemId.nome) {
                                        return produtoDetalhes.armazemId.nome;
                                    }
                                    if (typeof produtoDetalhes.armazemId === 'string') {
                                        const encontrado = armazens.find(a => a._id === produtoDetalhes.armazemId);
                                        return encontrado?.nome || '-';
                                    }
                                    return '-';
                                })()}
                            </span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">📦 Unidade</span>
                            <span className="produto-value">{getUnidadeLabel(produtoDetalhes.unidadeMedida)}</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">💰 Preço Venda</span>
                            <span className="produto-value">{formatarMoeda(produtoDetalhes.precoVenda)}</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">💲 Preço Compra</span>
                            <span className="produto-value">{formatarMoeda(produtoDetalhes.precoCompra)}</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">📊 Margem de Lucro</span>
                            <span className="produto-value" style={{ color: (produtoDetalhes.margemLucro || 0) > 0 ? '#10b981' : '#dc2626' }}>
                                {formatarPercentagem(produtoDetalhes.margemLucro)}
                            </span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">📦 Stock Atual</span>
                            <span className="produto-value">
                                <span style={{ color: getStatusStock(produtoDetalhes.stockAtual, produtoDetalhes.stockMinimo).color }}>
                                    {formatarNumero(produtoDetalhes.stockAtual)} unidades
                                </span>
                            </span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">⚠️ Stock Mínimo</span>
                            <span className="produto-value">{formatarNumero(produtoDetalhes.stockMinimo)} unidades</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">📊 Status Stock</span>
                            <span className="produto-value">
                                <span className={`produto-status-badge ${getStatusStock(produtoDetalhes.stockAtual, produtoDetalhes.stockMinimo).class}`}>
                                    <Icon name={getStatusStock(produtoDetalhes.stockAtual, produtoDetalhes.stockMinimo).icon} size={12} />
                                    {getStatusStock(produtoDetalhes.stockAtual, produtoDetalhes.stockMinimo).label}
                                </span>
                            </span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">💰 Valor Total Stock</span>
                            <span className="produto-value">{formatarMoeda(produtoDetalhes.custoTotalStock)}</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">📦 Total Comprado</span>
                            <span className="produto-value">{formatarNumero(produtoDetalhes.compraQuantidade)} unidades</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">📅 Data de Criação</span>
                            <span className="produto-value">{formatarDataHora(produtoDetalhes.createdAt)}</span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">🔄 Última Atualização</span>
                            <span className="produto-value">{formatarDataHora(produtoDetalhes.updatedAt)}</span>
                        </div>
                    </div>
                    {produtoDetalhes.descricao && (
                        <div className="produto-descricao-box">
                            <h4>📝 Descrição</h4>
                            <p>{produtoDetalhes.descricao}</p>
                        </div>
                    )}
                </div>

                {/* TAB GRÁFICOS */}
                <div className={`produto-modal-tab-panel ${detailsActiveTab === 'graficos' ? 'active' : ''}`}>
                    <div className="produto-graficos-grid">
                        <div className="produto-grafico-card">
                            <SimpleBarChart
                                title="📊 Distribuição de Stock"
                                labels={['Stock Atual', 'Stock Mínimo']}
                                data={[produtoDetalhes.stockAtual || 0, produtoDetalhes.stockMinimo || 0]}
                                colors={['#4f46e5', '#f59e0b']}
                                formatValue={formatarNumero}
                            />
                        </div>
                        <div className="produto-grafico-card">
                            <SimpleBarChart
                                title="💰 Comparação de Preços"
                                labels={['Preço Venda', 'Preço Compra']}
                                data={[produtoDetalhes.precoVenda || 0, produtoDetalhes.precoCompra || 0]}
                                colors={['#10b981', '#3b82f6']}
                                formatValue={formatarMoeda}
                            />
                        </div>
                        <div className="produto-grafico-card produto-gauge-card">
                            <div className="produto-gauge-wrapper">
                                <SimpleGauge
                                    value={produtoDetalhes.stockAtual || 0}
                                    max={Math.max(produtoDetalhes.stockAtual || 10, (produtoDetalhes.stockMinimo || 0) * 3)}
                                    label="Stock Atual"
                                    color={getStatusStock(produtoDetalhes.stockAtual, produtoDetalhes.stockMinimo).color}
                                    formatValue={formatarNumero}
                                />
                            </div>
                            <div className="produto-gauge-info">
                                <div className="produto-gauge-status">
                                    <span className="produto-status-label">Status:</span>
                                    <span className={`produto-status-badge ${getStatusStock(produtoDetalhes.stockAtual, produtoDetalhes.stockMinimo).class}`}>
                                        {getStatusStock(produtoDetalhes.stockAtual, produtoDetalhes.stockMinimo).label}
                                    </span>
                                </div>
                                <div className="produto-gauge-metrics">
                                    <span>Stock: {formatarNumero(produtoDetalhes.stockAtual)} unidades</span>
                                    <span>Mínimo: {formatarNumero(produtoDetalhes.stockMinimo)} unidades</span>
                                </div>
                            </div>
                        </div>
                        <div className="produto-grafico-card produto-metrics-card">
                            <h4 className="produto-chart-title">📈 Métricas Rápidas</h4>
                            <div className="produto-metrics-grid">
                                <div className="produto-metric-item">
                                    <span className="produto-metric-label">Margem de Lucro</span>
                                    <span className="produto-metric-value" style={{ color: (produtoDetalhes.margemLucro || 0) > 0 ? '#10b981' : '#dc2626' }}>
                                        {formatarPercentagem(produtoDetalhes.margemLucro)}
                                    </span>
                                </div>
                                <div className="produto-metric-item">
                                    <span className="produto-metric-label">Valor Total Stock</span>
                                    <span className="produto-metric-value">{formatarMoeda(produtoDetalhes.custoTotalStock)}</span>
                                </div>
                                <div className="produto-metric-item">
                                    <span className="produto-metric-label">Total Comprado</span>
                                    <span className="produto-metric-value">{formatarNumero(produtoDetalhes.compraQuantidade)} un.</span>
                                </div>
                                <div className="produto-metric-item">
                                    <span className="produto-metric-label">Status</span>
                                    <span className="produto-metric-value">
                                        <span className={`produto-status-badge ${produtoDetalhes.ativo ? 'stock-alto' : 'inactive'}`}>
                                            {produtoDetalhes.ativo ? 'Ativo' : 'Inativo'}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* TAB IMPOSTOS */}
                <div className={`produto-modal-tab-panel ${detailsActiveTab === 'impostos' ? 'active' : ''}`}>
                    <div className="produto-detalhes-grid produto-impostos-grid">
                        <div className="produto-info-item">
                            <span className="produto-label">🧾 IVA</span>
                            <span className="produto-value">
                                {produtoDetalhes.impostos?.usarIvaEmpresa
                                    ? `${configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? configEmpresa.iva : 'N/D'}% (Empresa)`
                                    : produtoDetalhes.impostos?.iva !== null ? `${produtoDetalhes.impostos.iva}%` : 'N/A'}
                            </span>
                        </div>
                        <div className="produto-info-item">
                            <span className="produto-label">🧾 ISPC</span>
                            <span className="produto-value">{produtoDetalhes.impostos?.ispc || 0}%</span>
                        </div>
                        <div className="produto-info-item produto-full-width">
                            <span className="produto-label">📋 Detalhes do IVA</span>
                            <span className="produto-value">
                                {produtoDetalhes.impostos?.usarIvaEmpresa
                                    ? 'Usando IVA configurado na empresa'
                                    : produtoDetalhes.impostos?.iva !== null
                                        ? `IVA específico do produto: ${produtoDetalhes.impostos.iva}%`
                                        : 'Nenhum IVA configurado'}
                            </span>
                        </div>
                        <div className="produto-info-item produto-full-width">
                            <span className="produto-label">📋 Detalhes do ISPC</span>
                            <span className="produto-value">
                                {produtoDetalhes.impostos?.ispc > 0
                                    ? `ISPC de ${produtoDetalhes.impostos.ispc}% aplicado`
                                    : 'Sem ISPC configurado'}
                            </span>
                        </div>
                    </div>
                </div>

                {/* TAB HISTÓRICO */}
                <div className={`produto-modal-tab-panel ${detailsActiveTab === 'historico' ? 'active' : ''}`}>
                    <div className="produto-historico-section">
                        <h4 className="produto-historico-title">
                            <Icon name="history" size={18} /> Histórico de Movimentos
                        </h4>
                        {produtoDetalhes.historicoEntradas && produtoDetalhes.historicoEntradas.length > 0 ? (
                            <>
                                <div className="produto-historico-timeline">
                                    {currentHistorico.map((entrada, index) => {
                                        const isEntrada = entrada.tipo === 'entrada' || entrada.quantidade > 0;
                                        const quantidadeAbs = Math.abs(entrada.quantidade || 0);
                                        const sinal = isEntrada ? '+' : '-';
                                        const cor = isEntrada ? '#10b981' : '#dc2626';
                                        const iconName = isEntrada ? 'add_box' : 'remove_circle';

                                        const nomeFornecedor = getNomeFornecedor(entrada.fornecedorId);

                                        return (
                                            <div key={index} className="produto-historico-item" style={{ borderLeftColor: cor }}>
                                                <div className="produto-historico-icon" style={{ background: isEntrada ? '#10b981' : '#dc2626' }}>
                                                    <Icon name={iconName} size={14} style={{ color: 'white' }} />
                                                </div>
                                                <div className="produto-historico-content">
                                                    <div className="produto-historico-header">
                                                        <span className="produto-historico-quantidade" style={{ color: cor }}>
                                                            {sinal}{formatarNumero(quantidadeAbs)} unidades
                                                        </span>
                                                        <span className="produto-historico-data">
                                                            {formatarDataHora(entrada.dataEntrada)}
                                                        </span>
                                                    </div>
                                                    <div className="produto-historico-detalhes">
                                                        <span>Preço Unitário: {formatarMoeda(entrada.precoUnitario)}</span>
                                                        {entrada.fornecedorId && (
                                                            <span>Fornecedor: {nomeFornecedor}</span>
                                                        )}
                                                        {entrada.observacao && (
                                                            <span className="produto-historico-observacao">{entrada.observacao}</span>
                                                        )}
                                                        {entrada.notaFiscal && (
                                                            <span className="produto-historico-nota">📄 NF: {entrada.notaFiscal}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                {renderHistoricoPagination()}
                            </>
                        ) : (
                            <div className="produto-historico-vazio">
                                <Icon name="history" size={32} />
                                <p>Nenhum movimento registado para este produto</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="produto-modal-footer">
                <button className="produto-btn-primary" onClick={() => handleEdit(produtoDetalhes)}>
                    <Icon name="edit" size={16} /> Editar
                </button>
                <button className="produto-btn-secondary" onClick={() => setShowDetailsModal(false)}>Fechar</button>
            </div>
        </div>
    </div>
)}

{/* MODAL DE CONFIRMAÇÃO DE EXCLUSÃO */}
{showDeleteModal && produtoToDelete && (
    <div className="produto-modal-overlay" onClick={closeDeleteModal}>
        <div className="produto-modal-content-popups produto-modal-confirm" onClick={(e) => e.stopPropagation()}>
            <div className="produto-modal-header">
                <h3><span className="produto-header-icon">⚠️</span> Confirmar Exclusão</h3>
                <button className="produto-modal-close" onClick={closeDeleteModal}>×</button>
            </div>
            <div className="produto-modal-body-exc">
                <div className="produto-confirm-icon warning">
                    <Icon name="warning" size={32} />
                </div>
                <h4>Remover produto?</h4>
                <p>Tem certeza que deseja remover o produto <strong>{produtoToDelete.nome}</strong>?</p>
                <p className="produto-confirm-subtext"><Icon name="info" size={14} /> Esta ação é irreversível.</p>
            </div>
            <div className="produto-modal-actions">
                <button className="produto-btn-confirm-danger" onClick={confirmDelete}>
                    <Icon name="delete_forever" size={16} /> Eliminar
                </button>
                <button className="produto-btn-cancel" onClick={closeDeleteModal}>Cancelar</button>
            </div>
        </div>
    </div>
)}

            {/* HEADER */}
            <div className="produtos-header">
                <div className="header-title">
                    <h2><Icon name="inventory_2" size={24} /> Gestão de Produtos</h2>
                    <p>Gerencie o stock e produtos da sua empresa</p>
                </div>
                <div className="header-actions">
                    <button className="btn-export" onClick={() => exportarProdutos('excel')} title="Exportar Excel">
                        <Icon name="file_download" size={18} /> Excel
                    </button>
                    <button className="btn-export" onClick={() => exportarProdutos('csv')} title="Exportar CSV">
                        <Icon name="file_download" size={18} /> CSV
                    </button>
                    <button className="btn-create" onClick={() => setShowCreateModal(true)}>
                        <Icon name="add" size={18} /> Novo Produto
                    </button>
                </div>
            </div>

            {/* MENSAGENS */}
            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    <Icon name={message.type === 'success' ? 'check_circle' : 'error'} size={16} />
                    <span>{message.text}</span>
                    <button className="alert-close" onClick={() => setMessage({ text: '', type: '' })}>×</button>
                </div>
            )}

            {/* KPIs */}
            <div className="produtos-kpi-grid">
                <div className="kpi-card primary">
                    <div className="kpi-icon"><Icon name="inventory_2" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarNumero(stats.total)}</span>
                        <span className="kpi-label">Total Produtos</span>
                    </div>
                </div>
                <div className="kpi-card success">
                    <div className="kpi-icon"><Icon name="check_circle" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarNumero(stats.comStock)}</span>
                        <span className="kpi-label">Com Stock</span>
                    </div>
                    <span className="kpi-change positive">{stats.total > 0 ? Math.round((stats.comStock / stats.total) * 100) : 0}%</span>
                </div>
                <div className="kpi-card warning">
                    <div className="kpi-icon"><Icon name="warning" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarNumero(stats.baixoStock)}</span>
                        <span className="kpi-label">Stock Baixo</span>
                    </div>
                </div>
                <div className="kpi-card info">
                    <div className="kpi-icon"><Icon name="attach_money" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarMoeda(stats.valorTotalStock)}</span>
                        <span className="kpi-label">Valor em Stock</span>
                    </div>
                </div>
            </div>

            {/* FILTROS */}
            <div className="produtos-filters">
                <div className="search-box">
                    <Icon name="search" size={18} />
                    <input type="text" placeholder="Pesquisar por nome, código, descrição, categoria ou fornecedor..." value={searchTerm || ''} onChange={(e) => setSearchTerm(e.target.value)} />
                    {searchTerm && (
                        <button className="search-clear" onClick={() => setSearchTerm('')}>
                            <Icon name="close" size={16} />
                        </button>
                    )}
                </div>
                <div className="filter-actions">
                    <button className="btn-filter" onClick={() => setShowFiltros(!showFiltros)}>
                        <Icon name="filter_list" size={18} />
                        {showFiltros ? 'Ocultar Filtros' : 'Filtros'}
                    </button>
                    <button className="btn-refresh" onClick={fetchProdutos} title="Atualizar">
                        <Icon name="refresh" size={18} />
                    </button>
                </div>
            </div>

            {/* FILTROS AVANÇADOS */}
            {showFiltros && (
                <div className="produtos-filtros-avancados">
                    <div className="filtros-row">
                        <div className="filtro-group">
                            <label>Categoria</label>
                            <select value={filtros.categoria} onChange={(e) => setFiltros({ ...filtros, categoria: e.target.value })}>
                                <option value="todos">Todas as Categorias</option>
                                {categorias.map(cat => (
                                    <option key={cat._id} value={cat._id}>{cat.nome}</option>
                                ))}
                            </select>
                        </div>
                        <div className="filtro-group">
                            <label>Fornecedor</label>
                            <select value={filtros.fornecedor} onChange={(e) => setFiltros({ ...filtros, fornecedor: e.target.value })}>
                                <option value="todos">Todos os Fornecedores</option>
                                {fornecedores.map(f => (
                                    <option key={f._id} value={f._id}>{f.nome}</option>
                                ))}
                            </select>
                        </div>
                        <div className="filtro-group">
                            <label>Status Stock</label>
                            <select value={filtros.statusStock} onChange={(e) => setFiltros({ ...filtros, statusStock: e.target.value })}>
                                <option value="todos">Todos</option>
                                <option value="sem_stock">🔴 Sem Stock</option>
                                <option value="baixo_stock">🟡 Stock Baixo</option>
                                <option value="stock_medio">🔵 Stock Médio</option>
                                <option value="stock_alto">🟢 Stock Alto</option>
                            </select>
                        </div>
                        <div className="filtro-group">
                            <label>Unidade de Medida</label>
                            <select value={filtros.unidadeMedida} onChange={(e) => setFiltros({ ...filtros, unidadeMedida: e.target.value })}>
                                <option value="todos">Todas</option>
                                {UNIDADES_MEDIDA.map(u => (
                                    <option key={u.value} value={u.value}>{u.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="filtro-group">
                            <label>Status</label>
                            <select value={filtros.ativo} onChange={(e) => setFiltros({ ...filtros, ativo: e.target.value })}>
                                <option value="todos">Todos</option>
                                <option value="ativo">✅ Ativos</option>
                                <option value="inativo">❌ Inativos</option>
                            </select>
                        </div>
                        <button className="btn-aplicar-filtros" onClick={() => filtrarProdutos()}>
                            <Icon name="filter_list" size={16} /> Aplicar
                        </button>
                        <button className="btn-limpar-filtros" onClick={limparFiltros}>
                            <Icon name="clear" size={16} /> Limpar
                        </button>
                    </div>
                </div>
            )}

            {/* TABELA */}
            {loading ? (
                <div className="loading-container">
                    <div className="spinner-large"></div>
                    <p>A carregar produtos...</p>
                </div>
            ) : (
                <div className="produtos-table-container">
                    <table className="produtos-table">
                        <thead>
                            <tr>
                                <th className="col-data">Data/Hora</th>
                                <th className="col-codigo">Código</th>
                                <th className="col-nome">Nome</th>
                                <th className="col-categoria">Categoria</th>
                                <th className="col-armazem">Armazém</th>
                                <th className="col-unidade">Unidade</th>
                                <th className="col-preco">Preço Venda</th>
                                <th className="col-stock">Stock</th>
                                <th className="col-status">Status</th>
                                <th className="col-acoes">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentProdutos.length === 0 ? (
                                <tr className="empty-row">
                                    <td colSpan="10">
                                        <div className="empty-state">
                                            <Icon name="inventory_2" size={48} />
                                            <p>Nenhum produto encontrado</p>
                                            <button className="btn-create-small" onClick={() => setShowCreateModal(true)}>
                                                Criar primeiro produto
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                currentProdutos.map(produto => {
                                    const status = getStatusStock(produto.stockAtual, produto.stockMinimo);
                                    const isAtivo = produto.ativo !== false;

                                    const armazemNome = produto.armazemId?.nome ||
                                        (typeof produto.armazemId === 'string'
                                            ? armazens.find(a => a._id === produto.armazemId)?.nome
                                            : null) ||
                                        '-';

                                    return (
                                        <tr key={produto._id} className={!isAtivo ? 'inactive-row' : ''}>
                                            <td className="col-data">
                                                <span className="data-hora-badge">
                                                    <span className="data">{formatarDataHora(produto.createdAt).split(' ')[0]}</span>
                                                    <span className="hora">{formatarDataHora(produto.createdAt).split(' ')[1]}</span>
                                                </span>
                                            </td>
                                            <td><span className="codigo-badge">{produto.codigo || '-'}</span></td>
                                            <td>
                                                <div className="produto-info">
                                                    <strong>{produto.nome}</strong>
                                                    {!isAtivo && (
                                                        <span className="status-badge inactive" style={{ fontSize: '0.5rem', padding: '0.1rem 0.4rem' }}>
                                                            Inativo
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>{produto.categoriaId?.nome || '-'}</td>
                                            <td>
                                                <span className="armazem-badge">
                                                    <Icon name="warehouse" size={12} />
                                                    {armazemNome}
                                                </span>
                                            </td>
                                            <td><span className="unidade-badge">{getUnidadeLabel(produto.unidadeMedida)}</span></td>
                                            <td>{formatarMoeda(produto.precoVenda)}</td>
                                            <td>
                                                <span className={`stock-value ${status.class}`}>
                                                    {formatarNumero(produto.stockAtual)}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`status-badge ${status.class}`}>
                                                    <Icon name={status.icon} size={12} />
                                                    {status.label}
                                                </span>
                                            </td>
                                            <td className="actions-cell">
                                                <button className="action-btn view" onClick={() => verDetalhes(produto)} title="Ver detalhes">
                                                    <Icon name="visibility" size={16} />
                                                </button>
                                                <button className="action-btn edit" onClick={() => handleEdit(produto)} title="Editar">
                                                    <Icon name="edit" size={16} />
                                                </button>
                                                <button className="action-btn delete" onClick={() => openDeleteModal(produto)} title="Excluir">
                                                    <Icon name="delete" size={16} />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                    {renderPagination()}
                </div>
            )}
        </div>
    );
}